import React, { useEffect } from 'react';

const ESSChatWidget = ({ enabled }) => {

  useEffect(() => {

    if (!enabled) return;

    // prevent multiple loads
    if (window.__ESS_CHAT_LOADED__) {
      window.ESSChat?.init({
        container: '#ess-ai-chat',
        getToken: () => JSON.parse(localStorage.getItem('token'))
      });
      return;
    }

    window.__ESS_CHAT_LOADED__ = true;

    // Load CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://test.nidhi.apcfss.in/agent/ess-chat-widget.css';
    document.head.appendChild(link);

    // Load Script
    const script = document.createElement('script');
    script.src = 'https://test.nidhi.apcfss.in/agent/ess-chat-widget.umd.js';
    script.async = true;

    script.onload = () => {
      window.ESSChat?.init({
        container: '#ess-ai-chat',
        getToken: () =>  JSON.parse(localStorage.getItem('token'))
      });
    };

    document.body.appendChild(script);

  }, [enabled]);

  if (!enabled) return null;

  return <div id="ess-ai-chat"></div>;
};


export default ESSChatWidget;